
export const NAV_HEIGHT_CHANGE_EV = 'NAV_HEIGHT_CHANGE';